import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { User } from '../users';

export interface TruckType {
    designation: string;
    _id: string;
    crudStatus: number;
    billingType: number;
    group: number;
    price: number;
    priceType: number;
    usageCount?: {
        total: number;
        dailyTrucksPlanned: number;
        trucks: number;
    };
    updatedAt?: string;
    createdAt?: string;
    isDumpAllowed?: boolean;
    defaultTonnage?: number;
    minTonnage?: number;
    maxTonnage?: number;
    displayOrder?: number;
}

interface TrucksTypesResponse {
    message: string;
    data: TruckType[];
}

export interface GetTrucksTypesQueries {
    active?: boolean;
    withUsage?: boolean;
}

export const getAllTrucksTypes = async (queries?: GetTrucksTypesQueries): Promise<TrucksTypesResponse> => {
    try {
        const response: AxiosResponse<TrucksTypesResponse> = await apiClient.get('/trucks-types', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface UpdateTruckTypeBody {
    designation?: string;
    crudStatus?: number;
    group?: number;
    price?: number;
    priceType?: number;
    isDumpAllowed?: boolean;
    defaultTonnage?: number | null;
    minTonnage?: number | null;
    maxTonnage?: number | null;
    displayOrder?: number | null;
}

export interface TruckTypeResponse {
    message: string;
    data: TruckType;
}

export const updateTruckType = async (truckId: string, data: UpdateTruckTypeBody): Promise<TruckTypeResponse> => {
    try {
        const response: AxiosResponse<TruckTypeResponse> = await apiClient.patch('/trucks-types/' + truckId, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface CreateTruckTypeBody {
    designation: string;
    crudStatus?: number;
    group?: number;
    price: number;
    priceType: number;
    isDumpAllowed?: boolean;
    defaultTonnage?: number | null;
    minTonnage?: number | null;
    maxTonnage?: number | null;
    displayOrder?: number | null;
}

export const createTruckType = async (data: CreateTruckTypeBody): Promise<TruckTypeResponse> => {
    try {
        const response: AxiosResponse<TruckTypeResponse> = await apiClient.post('/trucks-types', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
